<template>
  <div class="mx-md-3 my-md-3">
    <h4>Velg laveste nivå for varsling</h4>
    <p>
      Her kan du velge laveste ønskede fare&shy;nivå du vil motta varsel om.
      Klikk på ønsket nivå for å endre. Nivåene i rammen under er de du vil
      motta varsel om.
    </p>

    <div class="mt-4 mx-3">
      <div
        class="row pt-3 pb-2 selectable"
        :class="level4Class"
        v-on:click="newLevel(4)"
        v-if="!onlyShowYellow() && !onlyShowOrange()"
      >
        <div class="col-2 col-md-1 radiocolumn">
          <input
            v-if="activateLevel4()"
            type="radio"
            id="level4"
            value="4"
            v-model="minLevel"
          />
        </div>
        <div class="col-2 pt-1 px-2">
          <span class="level level-4 d-sm-none">4</span>
          <span class="level level-4 d-none d-sm-block">4</span>
        </div>
        <div class="col-8 col-md-9">
          <strong>Rødt nivå</strong>
          <br />
          <p class="select-text">{{ level4Text() }}</p>
        </div>
      </div>
      <div
        class="row py-2 selectable"
        :class="level3Class"
        v-on:click="newLevel(3)"
        v-if="!onlyShowYellow()"
      >
        <div class="col-2 col-md-1 radiocolumn">
          <input type="radio" id="level3" value="3" v-model="minLevel" />
        </div>
        <div class="col-2 pt-1 px-2">
          <span class="level level-3 d-sm-none">3</span>
          <span class="level level-3 d-none d-sm-block">3</span>
        </div>
        <div class="col-8 col-md-9">
          <strong>Oransje nivå</strong>
          <br />
          <p class="select-text">{{ level3Text() }}</p>
        </div>
      </div>
      <div
        class="row py-2 selectable"
        :class="level2Class"
        v-on:click="newLevel(2)"
      >
        <div class="col-2 col-md-1 radiocolumn">
          <input type="radio" id="level2" value="2" v-model="minLevel" />
        </div>
        <div class="col-2 pt-1 px-2">
          <span class="level level-2 d-sm-none">2</span>
          <span class="level level-2 d-none d-sm-block">2</span>
        </div>
        <div class="col-8 col-md-9">
          <strong>Gult nivå</strong>
          <small>(Anbefalt nivå)</small>
          <br />
          <p class="select-text">{{ level2Text() }}</p>
        </div>
      </div>
      <div class="row py-2">
        <div class="col-2 col-md-1 radiocolumn"></div>
        <div class="col-2 pt-1 px-2">
          <span class="level level-1 d-sm-none">1</span>
          <span class="level level-1 d-none d-sm-block">1</span>
        </div>
        <div class="col-8 col-md-9">
          <strong>Grønt nivå</strong>
          <br />
          <p class="select-text">Det sendes ikke varsler på dette nivået.</p>
        </div>
      </div>
      <div class="row py-2 mt-4">
        <div class="col-12 pl-0">
          <button
            type="button"
            class="btn btn-nve btn-primary mr-4"
            @click="selectLevel"
          >
            Ok, tilbake til varsel
          </button>
          <a href="#" @click.prevent="cancel">Avbryt</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TypeService from "../store/TypeService";
export default {
  name: "LevelSelector",
  props: {
    subscriptionType: {},
    selectedLevel: {
      type: Number,
    },
  },
  data() {
    return {
      minLevel: "2",
    };
  },
  created() {
    this.reset();
  },
  methods: {
    reset() {
      this.minLevel = this.selectedLevel.toString();
    },
    newLevel(level) {
      if (level > 3 && !this.activateLevel4()) {
        return;
      }
      this.minLevel = level.toString();
    },

    selectLevel() {
      // do nothing until "OK"
      this.$emit("levelSelected", parseInt(this.minLevel, 10));
    },
    cancel() {
      this.$emit("levelSelected", -1);
      this.reset();
    },
    hazardTypeId() {
      return this.subscriptionType.hazardTypeId;
    },
    level2Text() {
      switch (this.subscriptionType.hazardTypeId) {
        case TypeService.Flood:
          return (
            "Situasjon som krever oppfølging og kan medføre skader lokalt, som lokale oversvømmelser, og/eller erosjonsskader pga. raskt økende vannføring i bekker/småelver, " +
            "isgang, is i bekke-/elveløp, tele etc. Spesielt stor vannføring/vannstand i forhold til hva som er normalt for årstiden. Vannføring tett oppunder oransje nivå."
          );
        case TypeService.Landslide:
          return "Situasjon som krever oppfølging og kan medføre skader lokalt. Det ventes noen skredhendelser, enkelte store hendelser kan forekomme.";
        case TypeService.Rockslide:
          return "Bevegelsene i det ustabile fjellpartiet har passert en terskelverdi over de typiske sesongvariasjonene. Bevegelsen er ventet å vise svak akselerasjon. Det kan ventes en viss økning av småskred og/eller steinsprang i fjellpartiet. Sannsynligheten for et større fjellskred i nær framtid har økt. Beredskapen skal ved dette farenivået være planmessig dimensjonert for å håndtere et skred om én måned. For svært bratte fjellsider kan denne tiden være kortere (uker).";
        default:
          // MET varsler
          return "Utfordrende vær som kan medføre mindre konsekvenser.";
      }
    },
    level3Text() {
      switch (this.subscriptionType.hazardTypeId) {
        case TypeService.Flood:
          return (
            "Alvorlig situasjon som forekommer sjelden, krever beredskapsmessige forberedelser og kan medføre alvorlige skader som omfattende " +
            "oversvømmelser, erosjonsskader og flomskader på utsatte steder."
          );
        case TypeService.Rockslide:
          return "Bevegelsene i det ustabile fjellpartiet har passert en ny terskelverdi, og er forventet å vise en klar akselerasjon. Forekomst av småskred kan forventes å øke ytterligere. Et fjellskred i nær framtid er sannsynlig. Beredskapen ved dette farenivået skal være dimensjonert for å håndtere et skred om to uker. For svært bratte fjellsider kan denne tiden bli kortere (4-6 døgn).";
        case TypeService.Landslide:
          return "Alvorlig situasjon som forekommer sjelden, krever beredskapsmessige forberedelser og kan medføre alvorlige skader. Det ventes mange skredhendelser, noen kan få store konsekvenser.";
        case TypeService.BlowingSnow:
          return "Oransje nivå varsles ikke for snøfokk";
        case TypeService.Lightning:
          return "Oransje nivå varsles ikke for mye lyn";
        default:
          // MET varsler
          return (
            "Alvorlig vær som forekommer sjelden og kan medføre omfattende konsekvenser. Det vil være en reell fare for at liv og verdier kan gå tapt, " +
            "at veier kan bli stengt og avganger med båt, fly og annen transport bli kansellert."
          );
      }
    },
    level4Text() {
      switch (this.subscriptionType.hazardTypeId) {
        case TypeService.Flood:
          return (
            "Ekstrem situasjon som forekommer svært sjelden, krever tett oppfølging og kan medføre store skader som omfattende oversvømmelser, " +
            "erosjonsskader og flomskader på bebyggelse og infrastruktur."
          );
        case TypeService.Rockslide:
          return (
            "Bevegelsene i det ustabile fjellpartiet har nådd et nivå som tilsier at et fjellskred er svært sannsynlig, og nært forstående. I denne fasen er det forventet stor uro i fjellpartiet med daglige småskred, noe som kan føre til at hele eller deler av overvåkingssystemet blir satt ut av spill. Beredskapen skal ved overgangen til dette farenivået være dimensjonert for å håndtere et skred om 72 timer, og evakuering av hele fareområdet skal kunne gjennomføres i løpet av 12 timer, jf. TEK17 § 7-4." +
            " Dette farenivået vil vedvare også etter at et skred har gått, til overvåkingssystemer er reetablert og en ny farevurdering er gjennomført."
          );
        case TypeService.Landslide:
          return "Ekstrem situasjon som forekommer svært sjelden, krever tett oppfølging og kan medføre store skader. Det ventes svært mange skredhendelser, flere kan få store konsekvenser.";
        case TypeService.ForestFire:
          return "Rødt nivå benyttes for øyeblikket ikke for skogbrann.";
        case TypeService.RainFlood:
          return "Rødt nivå benyttes ikke for styrtregn.";
        case TypeService.Ice:
          return "Rødt nivå benyttes ikke for styrtregn.";
        case TypeService.PolarLow:
          return "Rødt nivå varsles ikke for polart lavtrykk";
        case TypeService.BlowingSnow:
          return "Rødt nivå varsles ikke for snøfokk";
        case TypeService.Lightning:
          return "Rødt nivå varsles ikke for mye lyn";
        default:
          // MET varsler
          return (
            "Ekstremværvarsel som har fått navn. Vær som forekommer svært sjelden, og kan medføre ekstreme konsekvenser, " +
            "stor fare for liv går tapt og at det blir store ødeleggelser på eiendom og infrastruktur."
          );
      }
    },
    onlyShowOrange() {
      return (
        this.subscriptionType.hazardTypeId === TypeService.PolarLow ||
        this.subscriptionType.hazardTypeId === TypeService.ForestFire ||
        this.subscriptionType.hazardTypeId === TypeService.RainFlood ||
        this.subscriptionType.hazardTypeId === TypeService.Ice
      );
    },
    onlyShowYellow() {
      return (
        this.subscriptionType.hazardTypeId === TypeService.BlowingSnow ||
        this.subscriptionType.hazardTypeId === TypeService.Lightning
      );
    },
    activateLevel4() {
      if (
        this.subscriptionType.hazardTypeId === TypeService.Lightning ||
        this.subscriptionType.hazardTypeId === TypeService.BlowingSnow ||
        this.subscriptionType.hazardTypeId === TypeService.PolarLow ||
        this.subscriptionType.hazardTypeId === TypeService.ForestFire ||
        this.subscriptionType.hazardTypeId === TypeService.RainFlood ||
        this.subscriptionType.hazardTypeId === TypeService.Ice
      ) {
        return false;
      }
      return true;
    },
  },
  computed: {
    level4Class() {
      if (this.minLevel === "4") {
        return "first-selected last-selected";
      }
      return "first-selected";
    },
    level3Class() {
      if (this.minLevel === "3") {
        if (
          this.subscriptionType.hazardTypeId === TypeService.PolarLow ||
          this.subscriptionType.hazardTypeId === TypeService.ForestFire ||
          this.subscriptionType.hazardTypeId === TypeService.RainFlood ||
          this.subscriptionType.hazardTypeId === TypeService.Ice
        )
          return "last-selected first-selected";
        else return "last-selected";
      }
      if (this.minLevel === "2") {
        if (
          this.subscriptionType.hazardTypeId === TypeService.PolarLow ||
          this.subscriptionType.hazardTypeId === TypeService.ForestFire ||
          this.subscriptionType.hazardTypeId === TypeService.RainFlood ||
          this.subscriptionType.hazardTypeId === TypeService.Ice
        )
          return "selected first-selected";
        else return "selected";
      }
      return "";
    },
    level2Class() {
      if (this.minLevel === "2") {
        if (this.subscriptionType.hazardTypeId === TypeService.BlowingSnow || this.subscriptionType.hazardTypeId === TypeService.Lightning)
          return "last-selected first-selected";
        else return "last-selected";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/levelselector.scss";
</style>
